import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import "./styles.css";

import {
  Table,
  Paper,
  Button,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
} from '@mui/material';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';

import ZoneCreate from '../pages/ZoneCRUDPages/create';

export default function ZoneListforCompany({ companyId }) {

  const [showbuildingcreate, setShowBuildingCreate] = useState('');
  const [zones, setZones] = useState([]);
  const [dataloaded, setDataLoaded] = useState(false);
  const [lightingModes, setLightingModes] = useState([]);
  const navigate = useNavigate();
  const [deleteZone, setDeleteZone] = useState(null);

  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

  useEffect(() => {
    axios
      .get(`${SERVER_URL}/api/lightingmodes`)
      .then(res => setLightingModes(res.data))
      .catch(err => console.error('Ne mogu dohvatiti lighting modes', err));
  }, []);

  useEffect(() => {
    if (companyId) {
      axios
        .get(`${SERVER_URL}/api/zonas/by-company/${companyId}`)
        .then((res) => setZones(res.data))
        .catch(() => console.log("Greška pri učitavanju zona"));
    }
  }, [companyId, dataloaded]);

  const handleDeleteZone = async () => {
    try {
      await axios.delete(`${SERVER_URL}/api/zonas/${deleteZone.id}`);
      setDeleteZone(null);
      setDataLoaded(prev => !prev);
    } catch (err) {
      console.error("Greška pri brisanju zone", err);
    }
  };

  return (
    <>
      <Helmet>
        <title>Pametna rasvjeta</title>
      </Helmet>

      <Container
        maxWidth={false}
        sx={{
          backgroundColor: '#00122E',
          minHeight: '70vh',
          padding: '20px',
          borderRadius: '8px',
        }}
      >
        <div>
          <Button
            sx={{
              minWidth: 100,
              backgroundColor: '#001B44',
              color: '#ff9800',                // 🔥 tekst orange
              border: '1px solid #ff9800',     // 🔥 border orange
              '&:hover': {
                backgroundColor: '#001B44',
                border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                color: '#ffa726'
              }
            }}
            onClick={() => setShowBuildingCreate(!showbuildingcreate)}
          >
            Dodaj novu zonu
          </Button>

          {showbuildingcreate &&
            <ZoneCreate
              companyid={companyId}
              onSuccess={() => {
                setShowBuildingCreate(false);
                setDataLoaded(!dataloaded);
              }}
              className="child"
            />
          }
        </div>

        <TableContainer
          component={Paper}
          sx={{
            mt: 3,
            backgroundColor: '#00122E',
            borderRadius: 2,
          }}
        >

          {/* 🔥 TITLE LIJEVO */}
          <Typography
            variant="h6"
            sx={{
              p: 2,
              pl: 3,
              color: '#ff9800',
              fontWeight: 600,
              textAlign: "left"
            }}
          >
            Zone kompanije
          </Typography>
          <Table
            sx={{
              width: '100%',
              tableLayout: 'fixed',

              '& .MuiTableCell-root': {
                borderBottom: '1px solid #374151',
                textAlign: 'center',   // ✅ FIX
              },

              '& .MuiTableCell-head': {
                color: '#ff9800 !important',
                borderBottom: '2px solid #374151',
              }
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: '#001B44',
                  '& .MuiTableCell-root': {
                    backgroundColor: '#001B44',
                    color: '#ff9800',
                    fontWeight: 700,
                    fontSize: '13px',
                    letterSpacing: '0.5px',
                    //borderBottom: '2px solid #3949ab',
                    padding: '10px',
                    textAlign: 'center'   // 👈 KLJUČNO
                  }
                }}
              >
                {[
                  'Naziv zone',
                  'Opis',
                  'Tip',
                  'Klasifikacija',
                  'Regija',
                  'Održavanje',
                  'Režim',
                  'Nadzor',
                  'Pregled',
                  'Uredi',
                  'Obriši'
                ].map((h) => (
                  <TableCell
                    key={h}
                    sx={{
                      color: '#ff9800',   // 🔥 OVO JE KLJUČ
                      fontWeight: 700,
                      fontSize: '13px',
                      textAlign: 'center',
                      borderBottom: '2px solid #374151',
                      backgroundColor: '#001B44'
                    }}
                  >
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {zones.map((zona) => (
                <TableRow
                  hover
                  key={zona.id}
                  sx={{
                    '&:hover': {
                      backgroundColor: '#001B44',
                    },
                  }}
                >

                  <TableCell sx={{ color: '#ff9800' }}>{zona.name}</TableCell>
                  <TableCell sx={{ color: '#ff9800' }}>{zona.description}</TableCell>
                  <TableCell sx={{ color: '#ff9800' }}>{zona.type}</TableCell>
                  <TableCell sx={{ color: '#ff9800' }}>{zona.classification}</TableCell>
                  <TableCell sx={{ color: '#ff9800' }}>{zona.region}</TableCell>
                  <TableCell sx={{ color: '#ff9800' }}>{zona.maintenanceCompany}</TableCell>

                  <TableCell sx={{ color: '#ff9800' }}>
                    {lightingModes.find(mode => mode.id === zona.lightingmodeid)?.name || 'Bez režima'}
                  </TableCell>

                  <TableCell sx={{ color: '#ff9800' }}>
                    {zona.isMonitored ? "DA" : "NE"}
                  </TableCell>

                  <TableCell>
                    <Button
                      sx={{
                        minWidth: 100,
                        backgroundColor: '#001B44',
                        color: '#ff9800',                // 🔥 tekst orange
                        border: '1px solid #ff9800',     // 🔥 border orange
                        '&:hover': {
                          backgroundColor: '#001B44',
                          border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                          color: '#ffa726'
                        }
                      }}
                      onClick={() => navigate("/dashboard/ZonesListAll", { state: { zoneId: zona.id } })}
                    >
                      Pregled
                    </Button>
                  </TableCell>

                  <TableCell>
                    <Button
                      sx={{
                        minWidth: 100,
                        backgroundColor: '#001B44',
                        color: '#ff9800',                // 🔥 tekst orange
                        border: '1px solid #ff9800',     // 🔥 border orange
                        '&:hover': {
                          backgroundColor: '#001B44',
                          border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                          color: '#ffa726'
                        }
                      }}
                      onClick={() => navigate("/zone/update", { state: zona })}
                    >
                      Uredi
                    </Button>
                  </TableCell>

                  <TableCell>
                    <Button
                      sx={{
                        minWidth: 100,
                        backgroundColor: '#001B44',
                        color: '#ff9800',                // 🔥 tekst orange
                        border: '1px solid #ff9800',     // 🔥 border orange
                        '&:hover': {
                          backgroundColor: '#001B44',
                          border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                          color: '#ffa726'
                        }
                      }}
                      onClick={() => setDeleteZone(zona)}
                    >
                      Obriši
                    </Button>
                  </TableCell>

                </TableRow>
              ))}
            </TableBody>
          </Table>

        </TableContainer>
      </Container>
      <Dialog
        open={!!deleteZone}
        onClose={() => setDeleteZone(null)}
        PaperProps={{
          sx: {
            backgroundColor: '#0f172a',
            color: '#fff',
            borderRadius: 3
          }
        }}
      >
        <DialogTitle>
          Obriši zonu
        </DialogTitle>

        <DialogContent>
          <Typography>
            Da li si siguran da želiš obrisati zonu "{deleteZone?.name}"?
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setDeleteZone(null)}
            sx={{ color: '#94a3b8' }}
          >
            Odustani
          </Button>

          <Button
            onClick={handleDeleteZone}
            sx={{
              backgroundColor: '#dc2626',
              color: '#fff',
              '&:hover': { backgroundColor: '#b91c1c' }
            }}
          >
            Obriši
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}